'use client';

import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export default function ProductScrollMotion({ images, activeCar }) {
    const containerRef = useRef(null);

    // Section 1
    const section1Ref = useRef(null);
    const { scrollYProgress: scrollY1 } = useScroll({
        target: section1Ref,
        offset: ["start end", "end start"]
    });

    // Scale from 1 to 0.95 and increase border radius
    const scale1 = useTransform(scrollY1, [0, 1], [1, 0.95]);
    const borderRadius1 = useTransform(scrollY1, [0, 1], ["0px", "32px"]);

    // Section 2
    const section2Ref = useRef(null);
    const { scrollYProgress: scrollY2 } = useScroll({
        target: section2Ref,
        offset: ["start end", "end start"]
    });

    // Parallax effect: starts shifted down (positive y) so it overlaps the third image,
    // and as we scroll down it moves up (negative y) to overlap the first image.
    const y2 = useTransform(scrollY2, [0, 1], ["40vh", "-40vh"]);


    return (
        <div ref={containerRef} className="relative w-full flex flex-col bg-white overflow-hidden pb-20" dir="rtl">

            {/* Section 1: Title and scaling image */}
            <div className="relative w-[80%] mx-auto flex flex-col items-center pt-10 md:pt-16 z-10" ref={section1Ref}>
                <h1 className="text-[12vw] md:text-[8vw] font-black leading-none tracking-tighter mb-8 text-black latinNumbers">
                    {activeCar?.english_name || '911'}
                </h1>
                <motion.div
                    style={{ scale: scale1, borderRadius: borderRadius1 }}
                    className="h-[60vh] md:h-[85vh] w-full mx-auto overflow-hidden shadow-xl"
                >
                    <img
                        src={images[0]}
                        alt="Porsche 911 Exterior"
                        className="w-full h-full object-cover"
                    />
                </motion.div>
            </div>

            {/* Section 2: Text and parallax overlapping image */}
            <div className="relative w-full px-6 md:px-24 flex flex-col md:flex-row items-center z-20 -mt-[40px]" ref={section2Ref}>
                {/* Text Side (40%) */}
                <div className="w-full md:w-[40%] pl-0 md:pl-16 py-10 md:py-24 mb-12 md:mb-0">
                    <h2 dir="ltr" className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-black leading-tight">
                        {activeCar?.title || (
                            <>Barsavosh</>
                        )}
                    </h2>
                    <p className="text-base md:text-lg text-gray-800 leading-relaxed font-medium whitespace-pre-line">
                        {activeCar?.description || activeCar?.decription || 'در آسمان اطمینان'}
                    </p>
                </div>

                {/* Image Side (60%) */}
                <div className="w-full md:w-[60%] h-[50vh] md:h-[80vh] relative">
                    <motion.div
                        style={{ y: y2 }}
                        className="w-full h-full absolute inset-0 z-20"
                    >
                        <img
                            src={images[1]}
                            alt="Porsche 911 Detail"
                            className="w-full h-full object-cover rounded-3xl shadow-2xl"
                        />
                    </motion.div>
                </div>
            </div>

            {/* Section 3: Bottom image */}
            <div className="relative w-[70%] mx-auto h-[60vh] md:h-[90vh] px-6 md:px-24 z-10 -mt-[30px]">
                <img
                    src={images[2]}
                    alt="Porsche 911 Rear"
                    className="w-full h-full object-cover rounded-3xl shadow-lg"
                />
            </div>

        </div>
    );
}
